// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IBrand {
    id: number;
    value: string;
    displayValue: string;
    nMVTISBrandId: number;
    nMVTISBrandValue: string;
    description: string;
    isRecognized: boolean;
    allowEndDate: boolean;
    sortOrder: number;
    active: boolean;
}

export class Brand implements IBrand, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public nMVTISBrandId: number;
    public nMVTISBrandValue: string;
    public description: string;
    public isRecognized: boolean;
    public allowEndDate: boolean;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Dismantled Brand
	**/
    get Dismantled(): IBrand {
        return this.FromId(1);
    }
    /**
		Returns Flood Damage Brand
	**/
    get FloodDamage(): IBrand {
        return this.FromId(2);
    }
    /**
		Returns Non-Repairable Brand
	**/
    get NonRepairable(): IBrand {
        return this.FromId(3);
    }
    /**
		Returns Reconstructed  Brand
	**/
    get Reconstructed(): IBrand {
        return this.FromId(4);
    }
    /**
		Returns Refurbished Brand
	**/
    get Refurbished(): IBrand {
        return this.FromId(5);
    }
    /**
		Returns Restored Salvage Brand
	**/
    get RestoredSalvage(): IBrand {
        return this.FromId(6);
    }
    /**
		Returns Retrofit Brand
	**/
    get Retrofit(): IBrand {
        return this.FromId(7);
    }
    /**
		Returns Salvage Brand
	**/
    get Salvage(): IBrand {
        return this.FromId(8);
    }
    /**
		Returns Stolen Brand
	**/
    get Stolen(): IBrand {
        return this.FromId(9);
    }
    /**
		Returns Crushed Brand
	**/
    get Crushed(): IBrand {
        return this.FromId(10);
    }
    /**
		Returns VIN Replaced by State Assigned VIN Brand
	**/
    get VINReplacedbyStateAssignedVIN(): IBrand {
        return this.FromId(70);
    }
    /**
		Returns Rebuilt Brand
	**/
    get Rebuilt(): IBrand {
        return this.FromId(11);
    }
    /**
		Returns Junk Brand
	**/
    get Junk(): IBrand {
        return this.FromId(12);
    }
    /**
		Returns State Assigned VIN Brand
	**/
    get StateAssignedVIN(): IBrand {
        return this.FromId(13);
    }
    /**
		Returns Clear Brand
	**/
    get Clear(): IBrand {
        return this.FromId(14);
    }
    /**
		Returns Fire damage Brand
	**/
    get Firedamage(): IBrand {
        return this.FromId(15);
    }
    /**
		Returns Hail damage Brand
	**/
    get Haildamage(): IBrand {
        return this.FromId(16);
    }
    /**
		Returns Salt water damage Brand
	**/
    get Saltwaterdamage(): IBrand {
        return this.FromId(17);
    }
    /**
		Returns Vandalism Brand
	**/
    get Vandalism(): IBrand {
        return this.FromId(18);
    }
    /**
		Returns Kit Brand
	**/
    get Kit(): IBrand {
        return this.FromId(19);
    }
    /**
		Returns Test Vehicle Brand
	**/
    get TestVehicle(): IBrand {
        return this.FromId(20);
    }
    /**
		Returns Collision Brand
	**/
    get Collision(): IBrand {
        return this.FromId(21);
    }
    /**
		Returns Salvage Retention Brand
	**/
    get SalvageRetention(): IBrand {
        return this.FromId(22);
    }
    /**
		Returns Prior Taxi Brand
	**/
    get PriorTaxi(): IBrand {
        return this.FromId(23);
    }
    /**
		Returns Prior Police Brand
	**/
    get PriorPolice(): IBrand {
        return this.FromId(24);
    }
    /**
		Returns Original Taxi Brand
	**/
    get OriginalTaxi(): IBrand {
        return this.FromId(25);
    }
    /**
		Returns Original Police Brand
	**/
    get OriginalPolice(): IBrand {
        return this.FromId(26);
    }
    /**
		Returns Remanufactured Brand
	**/
    get Remanufactured(): IBrand {
        return this.FromId(27);
    }
    /**
		Returns Warranty Return  Brand
	**/
    get WarrantyReturn(): IBrand {
        return this.FromId(28);
    }
    /**
		Returns Antique Brand
	**/
    get Antique(): IBrand {
        return this.FromId(29);
    }
    /**
		Returns Classic Brand
	**/
    get Classic(): IBrand {
        return this.FromId(30);
    }
    /**
		Returns Agricultural Vehicle Brand
	**/
    get AgriculturalVehicle(): IBrand {
        return this.FromId(31);
    }
    /**
		Returns Logging Vehicle Brand
	**/
    get LoggingVehicle(): IBrand {
        return this.FromId(32);
    }
    /**
		Returns Street Rod Brand
	**/
    get StreetRod(): IBrand {
        return this.FromId(33);
    }
    /**
		Returns Vehicle Contains Reissued VIN Brand
	**/
    get VehicleContainsReissuedVIN(): IBrand {
        return this.FromId(34);
    }
    /**
		Returns Replica Brand
	**/
    get Replica(): IBrand {
        return this.FromId(35);
    }
    /**
		Returns Totaled Brand
	**/
    get Totaled(): IBrand {
        return this.FromId(36);
    }
    /**
		Returns Owner Retained Brand
	**/
    get OwnerRetained(): IBrand {
        return this.FromId(37);
    }
    /**
		Returns Memorandum Copy Brand
	**/
    get MemorandumCopy(): IBrand {
        return this.FromId(38);
    }
    /**
		Returns Recovered Theft Brand
	**/
    get RecoveredTheft(): IBrand {
        return this.FromId(39);
    }
    /**
		Returns Prior Owner Retained Brand
	**/
    get PriorOwnerRetained(): IBrand {
        return this.FromId(40);
    }
    /**
		Returns Veh Non-conformity Uncorrected Brand
	**/
    get VehNonconformityUncorrected(): IBrand {
        return this.FromId(41);
    }
    /**
		Returns Veh Non-conformity Corrected Brand
	**/
    get VehNonconformityCorrected(): IBrand {
        return this.FromId(42);
    }
    /**
		Returns Veh Safety Defect Uncorrected Brand
	**/
    get VehSafetyDefectUncorrected(): IBrand {
        return this.FromId(43);
    }
    /**
		Returns Veh Safety Defect Corrected Brand
	**/
    get VehSafetyDefectCorrected(): IBrand {
        return this.FromId(44);
    }
    /**
		Returns Gray Market Non-compliant Brand
	**/
    get GrayMarketNoncompliant(): IBrand {
        return this.FromId(45);
    }
    /**
		Returns Gray Market Compliant Brand
	**/
    get GrayMarketCompliant(): IBrand {
        return this.FromId(46);
    }
    /**
		Returns Manufacturer Buy Back Brand
	**/
    get ManufacturerBuyBack(): IBrand {
        return this.FromId(47);
    }
    /**
		Returns Former Rental Brand
	**/
    get FormerRental(): IBrand {
        return this.FromId(48);
    }
    /**
		Returns Salvage--Stolen Brand
	**/
    get SalvageStolen(): IBrand {
        return this.FromId(49);
    }
    /**
		Returns Salvage Reason<>Damage/Stolen Brand
	**/
    get SalvageReasonDamageStolen(): IBrand {
        return this.FromId(50);
    }
    /**
		Returns Disclosed Damage Brand
	**/
    get DisclosedDamage(): IBrand {
        return this.FromId(51);
    }
    /**
		Returns Prior Non-Repairable/Repaired Brand
	**/
    get PriorNonRepairableRepaired(): IBrand {
        return this.FromId(52);
    }
    /**
		Returns Inoperable Vehicle Brand
	**/
    get InoperableVehicle(): IBrand {
        return this.FromId(53);
    }
    /**
		Returns Actual Brand
	**/
    get Actual(): IBrand {
        return this.FromId(54);
    }
    /**
		Returns Not Actual Brand
	**/
    get NotActual(): IBrand {
        return this.FromId(55);
    }
    /**
		Returns Odometer Tampering Verified Brand
	**/
    get OdometerTamperingVerified(): IBrand {
        return this.FromId(56);
    }
    /**
		Returns Exempt: Odometer Disclosure Brand
	**/
    get ExemptOdometerDisclosure(): IBrand {
        return this.FromId(57);
    }
    /**
		Returns Exceeds Mechanical Limits Brand
	**/
    get ExceedsMechanicalLimits(): IBrand {
        return this.FromId(58);
    }
    /**
		Returns Odometer may be Altered Brand
	**/
    get OdometermaybeAltered(): IBrand {
        return this.FromId(59);
    }
    /**
		Returns Odometer Replaced Brand
	**/
    get OdometerReplaced(): IBrand {
        return this.FromId(60);
    }
    /**
		Returns Reading at Time of Renewal Brand
	**/
    get ReadingatTimeofRenewal(): IBrand {
        return this.FromId(61);
    }
    /**
		Returns Odometer Discrepancy Brand
	**/
    get OdometerDiscrepancy(): IBrand {
        return this.FromId(62);
    }
    /**
		Returns Call Title Division Brand
	**/
    get CallTitleDivision(): IBrand {
        return this.FromId(63);
    }
    /**
		Returns Rectify Prev Exceeds Limits Brand
	**/
    get RectifyPrevExceedsLimits(): IBrand {
        return this.FromId(64);
    }
    /**
		Returns Junk Automobile Brand
	**/
    get JunkAutomobile(): IBrand {
        return this.FromId(65);
    }
    /**
		Returns Pending Junk Automobile Brand
	**/
    get PendingJunkAutomobile(): IBrand {
        return this.FromId(66);
    }
    /**
		Returns Undisclosed Lien Brand
	**/
    get UndisclosedLien(): IBrand {
        return this.FromId(67);
    }
    /**
		Returns Parts Only Brand
	**/
    get PartsOnly(): IBrand {
        return this.FromId(68);
    }
    /**
		Returns Bond Posted Brand
	**/
    get BondPosted(): IBrand {
        return this.FromId(69);
    }
    /**
		Returns Gray Market Brand
	**/
    get GrayMarket(): IBrand {
        return this.FromId(71);
    }
    /**
		Returns Hazardous Substance Contaminated Vehicle Brand
	**/
    get HazardousSubstanceContaminatedVehicle(): IBrand {
        return this.FromId(72);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Dismantled', displayValue: 'Dismantled', nMVTISBrandId: 7, nMVTISBrandValue: 'Dismantled', description: 'Dismantled', isRecognized: true, allowEndDate: true, sortOrder: 5, active: true });
        this._dictionary.add('2', { id: 2, value: 'FloodDamage', displayValue: 'Flood Damage', nMVTISBrandId: 1, nMVTISBrandValue: 'FloodDamage', description: 'Flood Damage', isRecognized: true, allowEndDate: true, sortOrder: 10, active: true });
        this._dictionary.add('3', { id: 3, value: 'Non-Repairable', displayValue: 'Non-Repairable', nMVTISBrandId: 8, nMVTISBrandValue: 'Junk', description: 'Non-Repairable', isRecognized: true, allowEndDate: true, sortOrder: 15, active: true });
        this._dictionary.add('4', { id: 4, value: 'Reconstructed', displayValue: 'Reconstructed ', nMVTISBrandId: 10, nMVTISBrandValue: 'Reconstructed', description: 'Reconstructed ', isRecognized: true, allowEndDate: true, sortOrder: 20, active: true });
        this._dictionary.add('5', { id: 5, value: 'Refurbished', displayValue: 'Refurbished', nMVTISBrandId: 13, nMVTISBrandValue: 'Refurbished', description: 'Refurbished', isRecognized: true, allowEndDate: true, sortOrder: 25, active: true });
        this._dictionary.add('6', { id: 6, value: 'RestoredSalvage', displayValue: 'Restored Salvage', nMVTISBrandId: 9, nMVTISBrandValue: 'Rebuilt', description: 'Restored Salvage', isRecognized: true, allowEndDate: true, sortOrder: 30, active: true });
        this._dictionary.add('7', { id: 7, value: 'Retrofit', displayValue: 'Retrofit', nMVTISBrandId: 46, nMVTISBrandValue: 'GrayMarketCompliant', description: 'Retrofit', isRecognized: true, allowEndDate: true, sortOrder: 35, active: true });
        this._dictionary.add('8', { id: 8, value: 'Salvage', displayValue: 'Salvage', nMVTISBrandId: 11, nMVTISBrandValue: 'Salvage -- Damage or Not Specified', description: 'Salvage', isRecognized: true, allowEndDate: true, sortOrder: 40, active: true });
        this._dictionary.add('9', { id: 9, value: 'Stolen', displayValue: 'Stolen', nMVTISBrandId: 49, nMVTISBrandValue: 'Salvage -- Stolen', description: 'Stolen', isRecognized: true, allowEndDate: true, sortOrder: 45, active: true });
        this._dictionary.add('10', { id: 10, value: 'Crushed', displayValue: 'Crushed', nMVTISBrandId: 53, nMVTISBrandValue: 'Crushed', description: 'Crushed', isRecognized: true, allowEndDate: false, sortOrder: 50, active: true });
        this._dictionary.add('70', { id: 70, value: 'VIN Replaced by State Assigned VIN', displayValue: 'VIN Replaced by State Assigned VIN', nMVTISBrandId: 43, nMVTISBrandValue: 'VIN Replaced by State Assigned VIN', description: '(43) VIN Replaced by State Assigned VIN', isRecognized: false, allowEndDate: false, sortOrder: 55, active: true });
        this._dictionary.add('11', { id: 11, value: 'Rebuilt', displayValue: 'Rebuilt', nMVTISBrandId: 9, nMVTISBrandValue: 'Rebuilt', description: '(09) Rebuilt', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: 'Junk', displayValue: 'Junk', nMVTISBrandId: 8, nMVTISBrandValue: 'Junk', description: '(08) Junk', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'StateAssignedVIN', displayValue: 'State Assigned VIN', nMVTISBrandId: 43, nMVTISBrandValue: 'VIN replaced by a new state assigned VIN', description: '(43) VIN replaced by a new state assigned VIN. Brand 43 has been placed on the old VIN in NMVTIS.', isRecognized: true, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, value: 'Clear', displayValue: 'Clear', nMVTISBrandId: 0, nMVTISBrandValue: 'Clear', description: '(00) Clear', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, value: 'Firedamage', displayValue: 'Fire damage', nMVTISBrandId: 2, nMVTISBrandValue: 'Firedamage', description: '(02) Fire damage', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('16', { id: 16, value: 'Haildamage', displayValue: 'Hail damage', nMVTISBrandId: 3, nMVTISBrandValue: 'Haildamage', description: '(03) Hail damage', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('17', { id: 17, value: 'Saltwaterdamage', displayValue: 'Salt water damage', nMVTISBrandId: 4, nMVTISBrandValue: 'Saltwaterdamage', description: '(04) Salt water damage', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('18', { id: 18, value: 'Vandalism', displayValue: 'Vandalism', nMVTISBrandId: 5, nMVTISBrandValue: 'Vandalism', description: '(05) Vandalism', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('19', { id: 19, value: 'Kit', displayValue: 'Kit', nMVTISBrandId: 6, nMVTISBrandValue: 'Kit', description: '(06) Kit', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('20', { id: 20, value: 'TestVehicle', displayValue: 'Test Vehicle', nMVTISBrandId: 12, nMVTISBrandValue: 'TestVehicle', description: '(12) Test Vehicle', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('21', { id: 21, value: 'Collision', displayValue: 'Collision', nMVTISBrandId: 14, nMVTISBrandValue: 'Collision', description: '(14) Collision', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('22', { id: 22, value: 'SalvageRetention', displayValue: 'Salvage Retention', nMVTISBrandId: 16, nMVTISBrandValue: 'SalvageRetention', description: '(16) Salvage Retention', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('23', { id: 23, value: 'PriorTaxi', displayValue: 'Prior Taxi', nMVTISBrandId: 17, nMVTISBrandValue: 'PriorTaxi', description: '(17) Prior Taxi', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('24', { id: 24, value: 'PriorPolice', displayValue: 'Prior Police', nMVTISBrandId: 18, nMVTISBrandValue: 'PriorPolice', description: '(18) Prior Police', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('25', { id: 25, value: 'OriginalTaxi', displayValue: 'Original Taxi', nMVTISBrandId: 19, nMVTISBrandValue: 'OriginalTaxi', description: '(19) Original Taxi', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('26', { id: 26, value: 'OriginalPolice', displayValue: 'Original Police', nMVTISBrandId: 20, nMVTISBrandValue: 'OriginalPolice', description: '(20) Original Police', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('27', { id: 27, value: 'Remanufactured', displayValue: 'Remanufactured', nMVTISBrandId: 21, nMVTISBrandValue: 'Remanufactured', description: '(21) Remanufactured', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('28', { id: 28, value: 'WarrantyReturn', displayValue: 'Warranty Return ', nMVTISBrandId: 23, nMVTISBrandValue: 'WarrantyReturn', description: '(23) Warranty Return ', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('29', { id: 29, value: 'Antique', displayValue: 'Antique', nMVTISBrandId: 24, nMVTISBrandValue: 'Antique', description: '(24) Antique', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('30', { id: 30, value: 'Classic', displayValue: 'Classic', nMVTISBrandId: 25, nMVTISBrandValue: 'Classic', description: '(25) Classic', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('31', { id: 31, value: 'AgriculturalVehicle', displayValue: 'Agricultural Vehicle', nMVTISBrandId: 26, nMVTISBrandValue: 'AgriculturalVehicle', description: '(26) Agricultural Vehicle', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('32', { id: 32, value: 'LoggingVehicle', displayValue: 'Logging Vehicle', nMVTISBrandId: 27, nMVTISBrandValue: 'LoggingVehicle', description: '(27) Logging Vehicle', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('33', { id: 33, value: 'StreetRod', displayValue: 'Street Rod', nMVTISBrandId: 28, nMVTISBrandValue: 'StreetRod', description: '(28) Street Rod', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('34', { id: 34, value: 'VehicleContainsReissuedVIN', displayValue: 'Vehicle Contains Reissued VIN', nMVTISBrandId: 29, nMVTISBrandValue: 'VehicleContainsReissuedVIN', description: '(29) Vehicle Contains Reissued VIN', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('35', { id: 35, value: 'Replica', displayValue: 'Replica', nMVTISBrandId: 30, nMVTISBrandValue: 'Replica', description: '(30) Replica', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('36', { id: 36, value: 'Totaled', displayValue: 'Totaled', nMVTISBrandId: 31, nMVTISBrandValue: 'Totaled', description: '(31) Totaled', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('37', { id: 37, value: 'OwnerRetained', displayValue: 'Owner Retained', nMVTISBrandId: 32, nMVTISBrandValue: 'OwnerRetained', description: '(32) Owner Retained', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('38', { id: 38, value: 'MemorandumCopy', displayValue: 'Memorandum Copy', nMVTISBrandId: 34, nMVTISBrandValue: 'MemorandumCopy', description: '(34) Memorandum Copy', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('39', { id: 39, value: 'RecoveredTheft', displayValue: 'Recovered Theft', nMVTISBrandId: 36, nMVTISBrandValue: 'RecoveredTheft', description: '(36) Recovered Theft', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('40', { id: 40, value: 'PriorOwnerRetained', displayValue: 'Prior Owner Retained', nMVTISBrandId: 38, nMVTISBrandValue: 'PriorOwnerRetained', description: '(38) Prior Owner Retained', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('41', { id: 41, value: 'VehNon-conformityUncorrected', displayValue: 'Veh Non-conformity Uncorrected', nMVTISBrandId: 39, nMVTISBrandValue: 'VehNon-conformityUncorrected', description: '(39) Vehicle Non-conformity Uncorrected', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('42', { id: 42, value: 'VehNon-conformityCorrected', displayValue: 'Veh Non-conformity Corrected', nMVTISBrandId: 40, nMVTISBrandValue: 'VehNon-conformityCorrected', description: '(40) Vehicle Non-conformity Corrected', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('43', { id: 43, value: 'VehSafetyDefectUncorrected', displayValue: 'Veh Safety Defect Uncorrected', nMVTISBrandId: 41, nMVTISBrandValue: 'VehSafetyDefectUncorrected', description: '(41) Vehicle Safety Defect Uncorrected', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('44', { id: 44, value: 'VehSafetyDefectCorrected', displayValue: 'Veh Safety Defect Corrected', nMVTISBrandId: 42, nMVTISBrandValue: 'VehSafetyDefectCorrected', description: '(42) Vehicle Safety Defect Corrected', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('45', { id: 45, value: 'GrayMarketNon-compliant', displayValue: 'Gray Market Non-compliant', nMVTISBrandId: 45, nMVTISBrandValue: 'GrayMarketNon-compliant', description: '(45) Gray Market', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('46', { id: 46, value: 'GrayMarketCompliant', displayValue: 'Gray Market Compliant', nMVTISBrandId: 46, nMVTISBrandValue: 'GrayMarketCompliant', description: '(46) Gray Market', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('47', { id: 47, value: 'ManufacturerBuyBack', displayValue: 'Manufacturer Buy Back', nMVTISBrandId: 47, nMVTISBrandValue: 'ManufacturerBuyBack', description: '(47) Manufacturer Buy Back', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('48', { id: 48, value: 'FormerRental', displayValue: 'Former Rental', nMVTISBrandId: 48, nMVTISBrandValue: 'FormerRental', description: '(48) Former Rental', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('49', { id: 49, value: 'Salvage--Stolen', displayValue: 'Salvage--Stolen', nMVTISBrandId: 49, nMVTISBrandValue: 'Salvage--Stolen', description: '(49) Salvage--Stolen', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('50', { id: 50, value: 'SalvageReason<>Damage/Stolen', displayValue: 'Salvage Reason<>Damage/Stolen', nMVTISBrandId: 50, nMVTISBrandValue: 'SalvageReason<>Damage/Stolen', description: '(50) Salvage--Reasons Other Than Damage or Stolen', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('51', { id: 51, value: 'DisclosedDamage', displayValue: 'Disclosed Damage', nMVTISBrandId: 51, nMVTISBrandValue: 'DisclosedDamage', description: '(51) Disclosed Damage', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('52', { id: 52, value: 'PriorNon-Repairable/Repaired', displayValue: 'Prior Non-Repairable/Repaired', nMVTISBrandId: 52, nMVTISBrandValue: 'PriorNon-Repairable/Repaired', description: '(52) Prior Non-Repairable / Repaired', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('53', { id: 53, value: 'InoperableVehicle', displayValue: 'Inoperable Vehicle', nMVTISBrandId: 54, nMVTISBrandValue: 'InoperableVehicle', description: '(54) Inoperable Vehicle', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('54', { id: 54, value: 'Actual', displayValue: 'Actual', nMVTISBrandId: 68, nMVTISBrandValue: 'Actual', description: '(68) Actual', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('55', { id: 55, value: 'NotActual', displayValue: 'Not Actual', nMVTISBrandId: 69, nMVTISBrandValue: 'NotActual', description: '(69) Not Actual', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('56', { id: 56, value: 'OdometerTamperingVerified', displayValue: 'Odometer Tampering Verified', nMVTISBrandId: 70, nMVTISBrandValue: 'Not Actual - OdometerTamperingVerified', description: '(70) Not Actual - Odometer tampering verified', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('57', { id: 57, value: 'Exempt:OdometerDisclosure', displayValue: 'Exempt: Odometer Disclosure', nMVTISBrandId: 71, nMVTISBrandValue: 'Exempt:OdometerDisclosure', description: '(71) Exempt from Odometer Disclosure', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('58', { id: 58, value: 'ExceedsMechanicalLimits', displayValue: 'Exceeds Mechanical Limits', nMVTISBrandId: 72, nMVTISBrandValue: 'ExceedsMechanicalLimits', description: '(72) Exceeds Mechanical Limits', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('59', { id: 59, value: 'OdometermaybeAltered', displayValue: 'Odometer may be Altered', nMVTISBrandId: 73, nMVTISBrandValue: 'OdometermaybeAltered', description: '(73) Odometer may be Altered', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('60', { id: 60, value: 'OdometerReplaced', displayValue: 'Odometer Replaced', nMVTISBrandId: 74, nMVTISBrandValue: 'OdometerReplaced', description: '(74) Odometer Replaced', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('61', { id: 61, value: 'ReadingatTimeofRenewal', displayValue: 'Reading at Time of Renewal', nMVTISBrandId: 75, nMVTISBrandValue: 'ReadingatTimeofRenewal', description: '(75) Reading at Time of Renewal', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('62', { id: 62, value: 'OdometerDiscrepancy', displayValue: 'Odometer Discrepancy', nMVTISBrandId: 76, nMVTISBrandValue: 'OdometerDiscrepancy', description: '(76) Odometer Discrepancy', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('63', { id: 63, value: 'CallTitleDivision', displayValue: 'Call Title Division', nMVTISBrandId: 77, nMVTISBrandValue: 'CallTitleDivision', description: '(77) Call Title Division', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('64', { id: 64, value: 'RectifyPrevExceedsLimits', displayValue: 'Rectify Prev Exceeds Limits', nMVTISBrandId: 78, nMVTISBrandValue: 'RectifyPrevExceedsMechanicalLimits', description: '(78) Rectify Previous Exceeds Mechanical Limits Brand ', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('65', { id: 65, value: 'JunkAutomobile', displayValue: 'Junk Automobile', nMVTISBrandId: 91, nMVTISBrandValue: 'JunkAutomobile', description: '(91) Junk Automobile', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('66', { id: 66, value: 'PendingJunkAutomobile', displayValue: 'Pending Junk Automobile', nMVTISBrandId: 90, nMVTISBrandValue: 'PendingJunkAutomobile', description: '(90) Pending Junk Automobile', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('67', { id: 67, value: 'UndisclosedLien', displayValue: 'Undisclosed Lien', nMVTISBrandId: 37, nMVTISBrandValue: 'UndisclosedLien', description: '(37) Undisclosed Lien', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('68', { id: 68, value: 'PartsOnly', displayValue: 'Parts Only', nMVTISBrandId: 35, nMVTISBrandValue: 'PartsOnly', description: '(35) Parts Only', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('69', { id: 69, value: 'BondPosted', displayValue: 'Bond Posted', nMVTISBrandId: 33, nMVTISBrandValue: 'BondPosted', description: '(33) Bond Posted', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('71', { id: 71, value: 'GrayMarket', displayValue: 'Gray Market', nMVTISBrandId: 22, nMVTISBrandValue: 'Gray Market', description: '(22) Gray Market', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
        this._dictionary.add('72', { id: 72, value: 'HazardousSubstanceContaminatedVehicle', displayValue: 'Hazardous Substance Contaminated Vehicle', nMVTISBrandId: 55, nMVTISBrandValue: 'Hazardous Substance Contaminated Vehicle', description: '(55) Hazardous Substance Contaminated Vehicle', isRecognized: false, allowEndDate: true, sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IBrand {
        return this._dictionary[id];
    }

    public FromValue(value: string): IBrand {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IBrand[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IBrand[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IBrand[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
